export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'b4abff6d-c269-4d60-a898-b3099f645b1a';
export const MODAL_CLOSE_SEC = 2.5;
